


































































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import {mapActions} from 'vuex';
import {API} from '@/services/api/api';
import IGlobalSetting from '@/models/globalsetting';
import {Utils} from '@/utils/Utils';
import validator from '@/utils/validator';
import validationMsgs from '@/constants/validation';
import {redirectTime} from '@/constants/constants';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class EditGlobalSetting extends Vue {
  globalSettingData: IGlobalSetting;
  //loader and helper variables
  isScreenLoading = true;
  updating = false;
  showSuccessToast: any;
  showErrorToast: any;

  //validation variables
  mailFromValidationMsg = null;
  mailServerValidationMsg = null;
  userIdValidationMsg = null;
  passwordValidationMsg = null;
  portValidationMsg = null;
  inspectionMedValidationMsg = null;
  inspectionHighValidationMsg = null;
  inspectionMustValidationMsg = null;

  mounted() {
    this.getGlobalSetting();
  }
  //validation
  validateMailFrom() {
    const email = this.globalSettingData.mailFrom;
    if (validator.isNullOrEmpty(email)) {
      this.mailFromValidationMsg = validationMsgs.required;
      return false;
    } else if (validator.isEmailInValid(email)) {
      this.mailFromValidationMsg = validationMsgs.emailInvalid;
      return false;
    } else {
      this.mailFromValidationMsg = null;
      return true;
    }
  }
  validateMailServerAddress() {
    const address = this.globalSettingData.mailServerAddress;
    if (validator.isNullOrEmpty(address)) {
      this.mailServerValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.mailServerValidationMsg = null;
      return true;
    }
  }
  validateUserId() {
    const userId = this.globalSettingData.mailUid;
    if (validator.isNullOrEmpty(userId)) {
      this.userIdValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.userIdValidationMsg = null;
      return true;
    }
  }
  validatePassword() {
    const pass = this.globalSettingData.mailPwd;
    if (validator.isNullOrEmpty(pass)) {
      this.passwordValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.passwordValidationMsg = null;
      return true;
    }
  }
  validatePortNumber() {
    const port = this.globalSettingData.portNum;
    if (validator.isNullOrEmpty(port)) {
      this.portValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.portValidationMsg = null;
      return true;
    }
  }
  validateInspectionMed() {
    const inspection = this.globalSettingData.reInspectionGapSevMediun;
    if (validator.isNullOrEmpty(inspection)) {
      this.inspectionMedValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.inspectionMedValidationMsg = null;
      return true;
    }
  }
  validateInspectionHigh() {
    const inspection = this.globalSettingData.reInspectionGapSevHigh;
    if (validator.isNullOrEmpty(inspection)) {
      this.inspectionHighValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.inspectionHighValidationMsg = null;
      return true;
    }
  }
  validateInspectionMust() {
    const inspection = this.globalSettingData.reInspectionGapSevMustSee;
    if (validator.isNullOrEmpty(inspection)) {
      this.inspectionMustValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.inspectionMustValidationMsg = null;
      return true;
    }
  }
  validateAll() {
    return (
      this.validateMailFrom() &&
      this.validateMailServerAddress() &&
      this.validateUserId() &&
      this.validatePassword() &&
      this.validatePortNumber() &&
      this.validateInspectionMed() &&
      this.validateInspectionHigh() &&
      this.validateInspectionMust()
    );
  }

  //fetch list from api
  async getGlobalSetting() {
    try {
      let response = await API.getGlobalSetting();
      this.isScreenLoading = false;
      if (response.data !== '' && response.data !== null) {
        let data: IGlobalSetting = response.data;
        this.globalSettingData = data[0];
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  async onSubmitClick() {
    if (!this.validateAll()) return false;

    this.updating = true;
    const settingId = this.globalSettingData.settingId;
    try {
      const response = await API.updateGlobalSetting(settingId, this.globalSettingData);
      this.updating = false;
      if (response.data) {
        this.showSuccessToast({msg: 'Record updated'});
        setTimeout(() => this._clickHandler(), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (e) {
      this.updating = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  _clickHandler() {
    this.$router.go(-1);
  }
}
